import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '@siat-fe/env';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DynamicFormHttpService {
  private httpClient = inject(HttpClient);
  private baseUrl = environment.baseUrl;

  fetchGetFileById(
    id: string,
    fromMoniser?: boolean
  ): Observable<{
    campo: string;
    file: string;
    fileId: string;
    nomeFile: string;
    type: string;
  }> {
    let params = new HttpParams();
    params = params.set('fromMoniser', fromMoniser);
    return this.httpClient.get<{
      campo: string;
      file: string;
      fileId: string;
      nomeFile: string;
      type: string;
    }>(`${this.baseUrl}/v1/fileupload/download/${id}`, {
      params,
    });
  }

  fetchDeleteFile(id: string, fromMoniser?: boolean): Observable<void> {
    let params = new HttpParams();
    params = params.set('fromMoniser', fromMoniser);
    return this.httpClient.delete<void>(`${this.baseUrl}/v1/fileupload/${id}`, {
      params,
    });
  }
}
